/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxValue: NonNullable<unknown> }} Pure_Sweet_Robin_SingInputs */

const en_pure_sweet_robin_sing = /** @type {(inputs: Pure_Sweet_Robin_SingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`To ${i?.maxValue}`)
};

const de_pure_sweet_robin_sing = /** @type {(inputs: Pure_Sweet_Robin_SingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bis ${i?.maxValue}`)
};

/**
* | output |
* | --- |
* | "To {maxValue}" |
*
* @param {Pure_Sweet_Robin_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pure_sweet_robin_sing = /** @type {((inputs: Pure_Sweet_Robin_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pure_Sweet_Robin_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pure_sweet_robin_sing(inputs)
	return de_pure_sweet_robin_sing(inputs)
});